import { IS_PROD } from "@/config/appConfig";
import { BRAND_CONST } from "@/config/constants";

export const EMAIL_CAMPAIGN_CONST = {
  SCHEDULED_TYPE: {
    NOW: {
      label: "Send Now",
      value: "Send Now",
    },
    SCHEDULED: {
      label: "Schedule For Later",
      value: "Schedule For Later",
    },
  },
  TEMPLATES: [
    {
      id: 1,
      title: "50% Off",
      img: "/img/email-campaign/50off.png",
      customer_list: "Frequent Late-Night Orderers",
      contact_count: "1,944",
      subject: "Pick Your Pizza, Pay Half the Price 🍕",
    },
    {
      id: 2,
      title: "Free Small Pizza",
      img: "/img/email-campaign/free.png",
      customer_list: "Late-Night High Value Customers",
      contact_count: "634",
      subject: "Because One Pizza’s Never Enough…The Second’s on Us!",
    },
    {
      id: 3,
      title: "40% Off",
      img: "/img/email-campaign/40off.png",
      customer_list: "Customers With 500+ Points",
      contact_count: "634",
      subject: "Night Owls Eat Better with 40% Off 🍕🌙",
    },
  ],
  AVAILABLE_TO: IS_PROD ? [BRAND_CONST.DOMINO_DEMO_BRAND_ID] : ["all"],
};
